import React from "react";
import { Globe, Check, Loader2 } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { useLanguage } from "../context/LanguageContext";
import { LANGUAGES } from "../content/defaultContent";

export const LanguageSelector = ({ dark = false }) => {
  const { lang, changeLang, loading } = useLanguage();
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-selector-trigger"
          aria-label="Sélecteur de langue"
          className={`flex items-center gap-2 text-xs uppercase tracking-[0.15em] transition-opacity duration-300 hover:opacity-60 ${
            dark ? "text-white" : "text-brand-black"
          }`}
        >
          {loading ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <Globe className="h-4 w-4" />
          )}
          <span className="hidden sm:inline">{current.code.toUpperCase()}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="min-w-[180px] rounded-none border-brand-grey bg-white p-1"
        data-testid="language-selector-menu"
      >
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`language-option-${l.code}`}
            onClick={() => changeLang(l.code)}
            className="flex cursor-pointer items-center justify-between gap-3 rounded-none px-3 py-2.5 text-sm text-brand-black focus:bg-brand-beige"
          >
            <span className="flex items-center gap-3">
              <span className="text-base">{l.flag}</span>
              <span className="font-sans">{l.label}</span>
            </span>
            {lang === l.code && <Check className="h-4 w-4 text-brand-gold" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
